import { AFTER_INTERACTIONS } from './after.js';
import { BOOTSTRAP_INTERACTIONS } from './bootstrap.js';
import { CALENDAR_INTERACTIONS } from './calendar.js';
import { CATALOGUE_INTERACTIONS } from './catalogue.js';
import { CHRONICLE_INTERACTIONS } from './chronicle.js';
import { DOCUMENTS_INTERACTIONS } from './documents.js';
import { FOUNDRY_INTERACTIONS } from './foundry.js';
import { HISTORY_INTERACTIONS } from './history.js';
import { IMPORT_INTERACTIONS } from './import.js';
import { INBOX_INTERACTIONS } from './inbox.js';
import { LEDGER_INTERACTIONS } from './ledger.js';
import { LINKS_INTERACTIONS } from './links.js';
import { NAV_INTERACTIONS } from './nav.js';
import { READ_INTERACTIONS } from './read.js';
import { REFERENCE_INTERACTIONS } from './reference.js';
import { REVIEW_INTERACTIONS } from './review.js';
import { RUN_INTERACTIONS } from './run.js';
import { SESSIONS_INTERACTIONS } from './sessions.js';
import { SHEET_FORM_INTERACTIONS } from './sheet-form.js';
import { SHEETS_CARDS_INTERACTIONS } from './sheets-cards.js';
import { SHEETS_PC_INTERACTIONS } from './sheets-pc.js';
import { SHELL_INTERACTIONS } from './shell.js';
import { TEMPLATES_INTERACTIONS } from './templates.js';
import { TRASH_INTERACTIONS } from './trash.js';
import { TYPES_INTERACTIONS } from './types.js';
import { UNDO_INTERACTIONS } from './undo.js';
import { VIEWS_INTERACTIONS } from './views.js';
import { WHEN_INTERACTIONS } from './when.js';
export { UI_MODULES } from './types-def.js';
/**
 * UI interaction checklist rows, one file per module (test strategy section 7), in the order of
 * `UI_MODULES`.
 */
export const UI_INTERACTIONS = Object.freeze([
    ...SHELL_INTERACTIONS,
    ...NAV_INTERACTIONS,
    ...DOCUMENTS_INTERACTIONS,
    ...LINKS_INTERACTIONS,
    ...TYPES_INTERACTIONS,
    ...TEMPLATES_INTERACTIONS,
    ...HISTORY_INTERACTIONS,
    ...TRASH_INTERACTIONS,
    ...READ_INTERACTIONS,
    ...INBOX_INTERACTIONS,
    ...CATALOGUE_INTERACTIONS,
    ...WHEN_INTERACTIONS,
    ...CHRONICLE_INTERACTIONS,
    ...CALENDAR_INTERACTIONS,
    ...LEDGER_INTERACTIONS,
    ...REFERENCE_INTERACTIONS,
    ...SHEET_FORM_INTERACTIONS,
    ...IMPORT_INTERACTIONS,
    ...VIEWS_INTERACTIONS,
    ...SESSIONS_INTERACTIONS,
    ...RUN_INTERACTIONS,
    ...AFTER_INTERACTIONS,
    ...BOOTSTRAP_INTERACTIONS,
    ...UNDO_INTERACTIONS,
    ...REVIEW_INTERACTIONS,
    // CS r6c (deliverable 205): Phase 2c's modules, last.
    ...FOUNDRY_INTERACTIONS,
    ...SHEETS_PC_INTERACTIONS,
    ...SHEETS_CARDS_INTERACTIONS,
]);
//# sourceMappingURL=index.js.map